import React, { useCallback, useEffect, useState } from 'react';
import { getQuizzes, iQuiz } from '../../interfaces/quiz';

import { Container, Content, GameContent } from './styles';
import { useParams, useNavigate } from 'react-router-dom';

import { usePopup } from '../../hooks/popup';
import { GameHeader } from '../../components/GameHeader';
import { Sidebar } from './Sidebar';
import { useTimerContext } from '../../hooks/TimerContext';
import { IoTriangleSharp } from 'react-icons/io5';

import quizIcon from '../../assets/icons/quiz-icon.png';

interface handleIndexProps {
  alternative: string;
  correct: boolean;
}

export const Quiz: React.FC = () => {
  const [quiz, setQuiz] = useState<iQuiz[]>([]);
  const [index, setIndex] = useState<number>(0);
  const [score, setScore] = useState<number>(0);
  const [isFinished, setIsFinished] = useState(false);

  const { id } = useParams();
  const { mountPopup } = usePopup();
  const { resetTimer } = useTimerContext();

  const navigate = useNavigate();

  useEffect(() => {
    const getQuiz = async () => {
      const quizResponse = await getQuizzes(Number(id));

      setQuiz(quizResponse);
    };
    getQuiz();
  }, [id]);

  const resetQuiz = useCallback(() => {
    setIndex(0);
    setScore(0);
    setIsFinished(false);
    resetTimer();
  }, [resetTimer]);

  const handleIndex = useCallback(
    (alt: handleIndexProps) => {
      if (quiz.length > index + 1) {
        setIndex((oldIndex) => oldIndex + 1);
      } else {
        setIsFinished(true);
        mountPopup({
          title: 'Parabéns!',
          message: 'Você finalizou o desafio! Sua pontuação: ' + score,
          buttons: [
            {
              buttonText: 'Voltar',
              buttonFunction: () => {
                navigate('/');
              },
            },
            {
              buttonText: 'Reiniciar',
              isPurple: true,
              buttonFunction: () => {
                resetQuiz();
              },
            },
          ],
          type: 'atencao',
        });
      }

      if (alt.correct === true) {
        setScore((oldScore) => oldScore + 10);
      }
    },
    [index, mountPopup, navigate, quiz.length, resetQuiz, score]
  );

  return (
    <Container>
      <GameHeader
        type="QUIZ"
        menuItems={[
          {
            buttonText: 'REINICIAR',
            buttonFunctions: () => {
              mountPopup({
                title: 'Atenção!',
                message: 'O jogo será reiniciado! Você tem certeza?',
                buttons: [
                  {
                    buttonText: 'Cancelar',
                  },
                  {
                    buttonText: 'Reiniciar',
                    isPurple: true,
                    buttonFunction: () => {
                      resetQuiz();
                    },
                  },
                ],
                type: 'atencao',
              });
            },
          },
          {
            buttonText: 'VER RANKING',
            buttonFunctions: () => {
              alert('teste');
            },
          },
          {
            buttonText: 'VER COMENTÁRIOS',
            buttonFunctions: () => {
              alert('teste');
            },
          },
        ]}
        currentScore={score}
        maxScore={quiz.length * 10}
      />
      <Content>
        <GameContent>
          <span>
            <p>
              {index + 1}/{quiz.length}
            </p>
            <p>
              <img src={quizIcon} alt="Game Icon" />
              QUIZ
            </p>
          </span>

          <div>
            <main>
              <section className="LeftSide">
                <img src={quiz && quiz[0]?.image} alt="Quiz question" />

                <span>
                  <h3>{quiz && quiz[index]?.question}</h3>
                </span>
              </section>
            </main>

            <Sidebar
              resetQuiz={resetQuiz}
              currentScore={score}
              maxScore={quiz.length * 10}
              quiz={quiz[index]}
              handleIndex={handleIndex}
            />
          </div>
        </GameContent>
        <p style={{ background: '#54ad48' }}>
          VER MAIS COMENTÁRIOS <IoTriangleSharp size={12} />
        </p>
      </Content>
    </Container>
  );
};
